import { render, staticRenderFns } from "./CardCenter.vue?vue&type=template&id=622897d9&scoped=true&"
import script from "./CardCenter.vue?vue&type=script&lang=js&"
export * from "./CardCenter.vue?vue&type=script&lang=js&"
import style0 from "./CardCenter.vue?vue&type=style&index=0&id=622897d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622897d9",
  null
  
)

export default component.exports